import React from 'react';
import {css} from 'emotion';

import Header from './Header'

/* global tw */

const styles = {
    listWrapper: css`
        ${tw`w-full overflow-y-scroll scrolling-touch`};
        background: #111118;
        background-image: radial-gradient(ellipse 40% 30% at 50% 0%, rgba(170,11,202,0.1), transparent 70%);
        border-radius: 28px 28px 0 0;
        height: 91.4511742891vh;
        padding-bottom: 100px;
        border-top: 1px solid rgba(170, 11, 202, 0.2);
        box-shadow: 0 -8px 40px rgba(0,0,0,0.5);
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    `,
    row: css`
        ${tw`w-full flex flex-wrap justify-between items-center px-6 lg:px-0 -mx-2 lg:mx-auto`};
        max-width: 82rem;
        @media (webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi){
            max-width: 75rem;
        }
    `,
}

const AppLayout = (props) => (
    <div className={css`
        ${tw`w-screen max-w-screen max-h-screen overflow-hidden relative z-0`};
        background: #0A0A0F;
        background-image:
            radial-gradient(ellipse 70% 50% at 50% 0%, rgba(170,11,202,0.2), transparent 65%),
            radial-gradient(ellipse 40% 30% at 90% 30%, rgba(125,14,222,0.12), transparent 70%),
            linear-gradient(180deg, #1A1A24 0%, #0A0A0F 100%);
        font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
    `}>
        <Header name={props.name} onClick={props.onClick}/>
        <div className={styles.listWrapper}>
            {props.children}
        </div>
    </div>
);

export default AppLayout;
